import CalculatorHelper from '@/services/calculator-service-helper';
import _ from 'lodash';

const socialnetworkList = ['fb', 'nb', 'tw', 'ig', 'yt'];

export default {
    calculateSocialNetworkScores: (projectBrandMetrics, metricWeights, pillarWeights, min, max) => {
        let normalisedWeightedData = normaliseAndWeightBrandMetric(projectBrandMetrics, metricWeights, min, max);
        return calculateScores(normalisedWeightedData, pillarWeights);
    }
};

function calculateScores (metricData, pillarWeights) {
    // For each brand column add all the property values in each axis to produce the final score for X, Y and Z axis
    _.each(metricData, (data) => {
        socialnetworkList.forEach(sn => {
            data[sn].xConversation = _.reduce(data[sn].xConversation, (r, v) => r + v, 0);
            data[sn].yQuality = _.reduce(data[sn].yQuality, (r, v) => r + v, 0);
            data[sn].zCommunity = _.reduce(data[sn].zCommunity, (r, v) => r + v, 0);
            data[sn].finalScore = CalculatorHelper.calculateFinalScore(
                data[sn].xConversation, data[sn].yQuality, data[sn].zCommunity, pillarWeights);
        });
    });
    return metricData;
}

function normaliseAndWeightBrandMetric (projectBrandMetrics, metricWeights, min, max) {
    let brandMetricDict = {};
    try {
        _.each(metricWeights, (metricWeight) => {
            let metricField = metricWeight.sysMetric;
            let minVal = min[metricField] || 0;
            let maxVal = max[metricField] || 0;

            _.each(projectBrandMetrics, (metric) => {
                if (!brandMetricDict.hasOwnProperty(metric.columnId)) {
                    brandMetricDict[metric.columnId] = {
                        columnId: metric.columnId,
                        fb: { xConversation: {}, yQuality: {}, zCommunity: {} },
                        tw: { xConversation: {}, yQuality: {}, zCommunity: {} },
                        yt: { xConversation: {}, yQuality: {}, zCommunity: {} },
                        ig: { xConversation: {}, yQuality: {}, zCommunity: {} },
                        nb: { xConversation: {}, yQuality: {}, zCommunity: {} },
                        _: { xConversation: {}, yQuality: {}, zCommunity: {} }
                    };
                }
                const obj = brandMetricDict[metric.columnId];
                // Calculate the normalised value
                let value = CalculatorHelper.calculateWeightedNormalisedValue(
                    metric[metricField], metricField, minVal, maxVal, metricWeight.weight);

                // Add the value to the relevant socialnetwork + axis
                obj[definedSocialNetwork(metricField)][definedAxis(metricWeight.axis)][metricField] = value;
            });
        });
    } catch (err) {
        console.error('[socialnetworks] invalid metrics ', err);
        return [];
    }
    return _.toArray(brandMetricDict);
}

function definedSocialNetwork (metricField) {
    if (metricField.toLowerCase().startsWith('facebook')) {
        return 'fb';
    }
    if (metricField.toLowerCase().startsWith('brandtopic') ||
        metricField.toLowerCase() === 'shareofconversation') {
        return 'nb';
    }
    if (metricField.toLowerCase().startsWith('instagram')) {
        return 'ig';
    }
    if (metricField.toLowerCase().startsWith('youtube')) {
        return 'yt';
    }
    if (metricField.toLowerCase().startsWith('twitter')) {
        return 'tw';
    }
    console.error('Invalid metric field', metricField);
    return '_';
}

function definedAxis (axis) {
    switch (axis) {
    case 'X':
        return 'xConversation';
    case 'Y':
        return 'yQuality';
    case 'Z':
        return 'zCommunity';
    default:
        throw new Error('invalid axis', axis);
    }
}
